/**
 * angelehnt an dojo.string.substitute
 * string.substitute("${replace} - ${me}", { replace: "foo", me: "bar" });
 * Ergebnis: foo - bar
 */

export default function (string, object) {
  var replacedString = string;
  for (var member in object) {
    replacedString = replacedString.replaceAll("${" + member + "}", object[member] === undefined || object[member] === null ? "" : object[member]);
  }
  return replacedString.replace(/\$\{\w*\}/g, "");
}
